<template>
  <div class="modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div style="text-align: center; color: #b50000; font-size: 1.4rem;">
          <button
            class="close"
            type="button"
            id="trial-payment-close"
            style="display:none"
            data-dismiss="modal"
            aria-hidden="true"
          >
            <span class="s7-close"></span>
          </button>
          Trial ends: <span id="due-trial"></span>
        </div>
        <div class="modal-header" style="padding-bottom: 0">
          <h4 class="modal-title">{{ t("Payment details") }}</h4>
        </div>
        <div style="text-align: center; font-size: 18px">
          {{ t("Start your subscription now") }}
        </div>
        <div
          style="text-align: center; padding-bottom: 10px; font-size: 14px;color: #099bc3"
        >
          {{ t("Cancel anytime") }}
        </div>
        <div class="modal-body">
          <div class="card">
            <div class="card-body">
              <form>
                <div class="form-group row">
                  <div class="col-12">
                    <div class="input-header">
                      <div class="title">{{ t("Company name") }}</div>
                    </div>
                    <input
                      class="form-control"
                      type="text"
                      placeholder=""
                      v-model="user.name"
                      autocomplete="off"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <div class="input-header">
                      <div class="title">{{ t("VAT number (optional)") }}</div>
                    </div>
                    <input
                      class="form-control"
                      type="text"
                      placeholder=""
                      v-model="user.vat"
                      autocomplete="off"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <div class="input-header">
                      <div class="title">{{ t("Address") }}</div>
                    </div>
                    <input
                      class="form-control"
                      type="text"
                      placeholder=""
                      v-model="user.address"
                      autocomplete="off"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <div class="input-header">
                      <div class="title">{{ t("E-mail for invoice") }}</div>
                    </div>
                    <input
                      class="form-control"
                      type="text"
                      v-model="user.email"
                      autocomplete="off"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <div class="input-header">
                      <div class="title">{{ t("Card details") }}</div>
                    </div>
                    <StripeCard ref="stripeCard" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-link btn-space btn-link-primary full"
            type="button"
          >
            {{ t("Confirm") }}
          </button>
        </div>
        <div style="text-align: center">
          {{ t("Email: support@maprint.com") }}
        </div>
        <div style="text-align: center">
          {{ t("Whatsapp: +44 7400 202587") }}
        </div>
        <!-- <div style="text-align: center">
          {{ t("Call: +1 386 766 4226") }}
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import StripeCard from "./StripeCard.vue";

import { mapState } from "vuex";
export default {
  data() {
    return {
      $payment: null,
      currentUser: {}
    };
  },
  computed: {
    ...mapState({
      user: state => state.user.data,
      ref: state => state.user.ref,
      refId: state => state.user.ref.id,
      firebase: state => state.firebase
    })
  },
  mounted() {
    const _this = this;
    _this.$payment = $("#payment");
    const $primaryBtn = _this.$payment.find(".btn-link-primary");
    const stripeCardRef = _this.$refs.stripeCard;

    $primaryBtn.click(async () => {
      const groupComponent = _this.$refs.stripeCard.$refs.elms;
      const cardComponent = _this.$refs.stripeCard.$refs.card;
      const cardElement = cardComponent.stripeElement;

      if (!_this.user.name) {
        alert(_this.t("Please enter a valid business name"));
        return false;
      }
      // if (!_this.user.vat) {
      //   alert(_this.t("Please enter a valid business VAT number"));
      //   return false;
      // }
      // if (!_this.user.address) {
      //   alert(_this.t("Please enter a valid business address"));
      //   return false;
      // }
      if (!_this.validateEmail(_this.user.email)) {
        alert(_this.t("Please enter a valid email address"));
        return false;
      }

      const result = await groupComponent.instance.createToken(cardElement);
      console.log("result", result);

      if (result.error) {
        alert(result.error.message);
        return false;
      } else if (result.token) {
        if (result.token.card && result.token.card.funding === "prepaid") {
          alert("Prepaid card not allowed!");
          return false;
        } else {
          await _this.ref.update(
            {
              collect: false,
              lock: null,
              name: _this.user.name,
              vat: _this.user.vat || null,
              address: _this.user.address,
              email: _this.user.email,
              payment: result.token
            },
            { merge: true }
          );
          $("#payment").modal("hide");
          location.reload();
        }
      }

      return false;
    });
  },
  components: {
    StripeCard
  }
};
</script>

<style lang="scss">
#app {
  #payment {
    .modal-content {
      max-width: 400px;
      padding: 20px;
      margin: 0 auto;
      margin-top: 14vh;
      .modal-header {
        justify-content: unset;
        text-align: center;
        .modal-title {
          width: 100%;
          & > small {
            font-size: 16px;
          }
        }
      }
      form {
        margin-bottom: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Payment.vue